import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import { getFeedback } from 'app/scripts/views/feedback/get-feedback';
import styles from './GetFeedback.less';
import { FeedbackOptions } from 'app/scripts/views/feedback/feedback-options';

interface GetFeedbackProps {
  className?: string;
  surveyName: string;
  placement?: string;
  context?: string;
  preface?: string;
  yesNoQuestion?: string;
  showFreeform?: boolean;
  customGetFeedback?: (props: FeedbackOptions) => void;
}

const format = forTemplate('get_feedback');

export const GetFeedback: React.FunctionComponent<GetFeedbackProps> = function Feedback(
  props,
) {
  const { className, children } = props;
  const { customGetFeedback, ...getFeedbackProps } = props;

  const onClick =
    (customGetFeedback && customGetFeedback(getFeedbackProps)) ||
    getFeedback(getFeedbackProps);

  return (
    <a className={className || styles.feedback} href="#" onClick={onClick}>
      {React.Children.count(children) > 0 ? children : format('feedback')}
    </a>
  );
};
